import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";
import { generateURL } from "../utilities";

// const cookies = new Cookies();
const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

// export const getCustomerList = async (data) => {
//     let token = sessionStorage.getItem(TOKEN_KEY);
//     // let token = cookies.get(TOKEN_KEY);
//     let fd = new FormData()
//     for (var key in data) {
//         fd.append(key, data[key]);
//     }
//     let res = await axios({ method: "POST",data: fd, url: `${API_ENDPOINT}customerlist`,headers: { Authorization: getToken() ? `Bearer ${getToken()}` : '', }})
//     return res
// };
export const getCustomerList = async () => {
  let res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}customers/list`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

/**
 * Fetch customer list with filters (for client-side export).
 * @param {Object} params - Same as customers/list (pageNo, limit, searchQuery, name, phone, email, city, state, customer_type, etc.)
 * @returns {Promise<{ data: Array, total_count: number, per_page: number }>}
 */
export const getCustomerListWithParams = async (params) => {
  const res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}customers/list${generateURL(params)}`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res.data;
};

/**
 * Export customers with the same filters as the list API.
 * @param {Object} params - Same filter params as customers/list (searchQuery, name, phone, email, city, state, registered_from, registered_to). Optionally limit for export size.
 * @returns {Promise<AxiosResponse>} Response with responseType: 'blob' for file download.
 */
export const exportCustomers = async (params) => {
  const fd = new FormData();
  const exportParams = { ...params };
  if (exportParams.pageNo !== undefined) delete exportParams.pageNo;
  exportParams.limit = exportParams.limit ?? 9999;
  for (const key in exportParams) {
    if (exportParams.hasOwnProperty(key) && exportParams[key] !== undefined && exportParams[key] !== null) {
      fd.append(key, exportParams[key]);
    }
  }
  const res = await axios({
    method: "post",
    url: `${API_ENDPOINT}customers/export${generateURL(exportParams)}`,
    data: fd,
    responseType: "blob",
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
    },
  });
  return res;
};

/**
 * Update customer block/unblock status.
 * @param {Object} params - { customer_id: number, status: "blocked" | "active" }
 * @returns {Promise}
 */
export const updateCustomerStatus = async (params) => {
  const fd = new FormData();
  fd.append("customer_id", params.customer_id);
  fd.append("status", params.status);
  const res = await axios({
    method: "POST",
    url: `${API_ENDPOINT}customers/update_status`,
    data: fd,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res.data;
};
